@if(isTableOverlayOpen) {
<div class="backdrop"></div>
@if(isTableOverlayOpen){
<div class="overlay-for-location">
  <div class="overlay-header-for-location straightline-overlay">
    <div class="header-width">
      <h5>{{ locationType }} <span>Group Cities</span></h5>
    </div>
    <div class="close-button">
      <up-icon
        name="close"
        (click)="closeOverlay()"
        (keydown.enter)="closeOverlay()"
        (keydown.space)="closeOverlay()"
      ></up-icon>
    </div>
  </div>
  @if(locationRows.length > 0){
  <div class="overlay-content">
    <lib-static-dynamic-table
      [isFixedTable]="true"
      [columns]="locationColumns"
      [rows]="locationRows"
      [showFixedColumn]="true"
      [height]="'36vh'"
    >
    </lib-static-dynamic-table>
  </div>
  } @if(locationRows.length === 0){
  <div class="overlay-content">
    <p class="move-right">No Data Available</p>
  </div>
  }
  <div class="button-row">
    <up-button button-style="contained">
      <button type="submit" (click)="closeOverlay()">Ok</button>
    </up-button>
  </div>
</div>
} }
